module.exports = __webpack_public_path__ + "static/polar-caseimg-fddd084c5434a25e5bd3dc42d6e5abab.jpg";